import { createTheme } from "@mui/material";
import { brandFonts, brandPurple, brandGray, brandSemantic } from "./tickitBrandTokens";

export function getPlatformColors(mode = "light") {
  if (mode === "dark") {
    return {
      brand: brandPurple.p700,
      brandLight: brandPurple.p500,
      brandPale: "rgba(107, 45, 197, 0.22)",
      brandDark: brandPurple.p900,
      shellBg: "#0E0520",
      contentBg: "#120828",
      surface: "#1A1025",
      surface2: "#221433",
      surface3: "#2D1A45",
      border: "rgba(255, 255, 255, 0.08)",
      border2: "rgba(255, 255, 255, 0.14)",
      text: "#F5F0FF",
      text2: "#C4B5D8",
      text3: "#9A8BAE",
      danger: brandSemantic.danger,
      warn: brandSemantic.warn,
      success: brandSemantic.success,
      info: brandSemantic.info,
      accent: "#FF6B35",
      accent2: "#00C896",
    };
  }
  return {
    brand: brandPurple.p700,
    brandLight: brandPurple.p600,
    brandPale: brandPurple.p100,
    brandDark: brandPurple.p800,
    shellBg: "#0E0520",
    contentBg: "#F7F5FB",
    surface: "#FFFFFF",
    surface2: "#F7F5FB",
    surface3: "#EDE8F5",
    border: "rgba(70,16,155,0.12)",
    border2: "rgba(70,16,155,0.22)",
    text: "#1A1025",
    text2: "#5A4E6E",
    text3: "#9A8BAE",
    danger: brandSemantic.danger,
    warn: brandSemantic.warn,
    success: brandSemantic.success,
    info: brandSemantic.info,
    accent: "#FF6B35",
    accent2: "#00C896",
  };
}

export function createTickitMuiTheme(mode = "light") {
  const isDark = mode === "dark";
  const pc = getPlatformColors(mode);

  return createTheme({
    palette: {
      mode: isDark ? "dark" : "light",
      primary: {
        main: brandPurple.p700,
        light: brandPurple.p500,
        dark: brandPurple.p800,
        contrastText: "#ffffff",
      },
      secondary: {
        main: brandPurple.p400,
        contrastText: "#ffffff",
      },
      background: {
        default: isDark ? pc.contentBg : "#ffffff",
        paper: isDark ? pc.surface : "#ffffff",
      },
      text: {
        primary: isDark ? pc.text : brandGray.gray900,
        secondary: isDark ? pc.text2 : brandGray.gray500,
      },
      divider: isDark ? pc.border : brandGray.gray200,
      error: { main: brandSemantic.danger },
      success: { main: brandSemantic.success },
    },
    typography: {
      fontFamily: brandFonts.body,
      h1: { fontFamily: brandFonts.display, fontWeight: 800 },
      h2: { fontFamily: brandFonts.display, fontWeight: 800 },
      h3: { fontFamily: brandFonts.display, fontWeight: 800 },
      h4: { fontFamily: brandFonts.display, fontWeight: 800 },
      h5: { fontFamily: brandFonts.display, fontWeight: 700 },
      h6: { fontFamily: brandFonts.display, fontWeight: 700 },
      body1: { fontFamily: brandFonts.body },
      body2: { fontFamily: brandFonts.body },
    },
    shape: { borderRadius: 12 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: brandFonts.display,
            borderRadius: 12,
            textTransform: "none",
            fontWeight: 700,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
            borderRadius: 16,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { fontFamily: brandFonts.body },
        },
      },
    },
  });
}
